import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import * as yup from 'yup';
import {useFormik} from 'formik';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Request from '../AxiosInstance';
import moment from 'moment';

export default function VerifyInfoForm({formState, handleSubmit}) {
	const validationSchema = yup.object({
		regCode: yup
			.string('')
			.required('Registration code is required'),
		lastName: yup
			.string('Enter your password')
			.required('Last name is required'),
		dob: yup
			.date('DOB is required')
			.required('DOB is required')
			.nullable()
			.typeError('Invalid DOB')
			.max(moment().subtract(12, 'years'), 'DOB is out of range')
			.min(moment().subtract(120, 'years'), 'DOB is out of range')
	});

	const formSubmit = async (formValue) => {
		const formData = {
			regCode: formValue.regCode,
			lastName: formValue.lastName,
			dob: moment(formValue.dob).format('YYYY-MM-DD')
		}

		const response = await Request.post('/auth/verify', formData);

		const combinedData = {
			...formData,
			...response
		};

		handleSubmit(combinedData);
	}

	const formik = useFormik({
		initialValues: {
			regCode: formState.regCode || '',
			lastName: '',
			dob: formState.dob,
		},
		validationSchema: validationSchema,
		onSubmit: (values) => {
			formSubmit(values)
		},
	});

	return (
		<React.Fragment>
			<Typography variant="h6" align={"center"} sx={{ pt: 2, pb: 2 }}>
				Verify your info
			</Typography>
			<form onSubmit={formik.handleSubmit}>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<TextField
							required
							id="regCode"
							name="regCode"
							label="Registration Code"
							fullWidth
							variant="outlined"
							disabled={formState.isCodePrefilled}
							value={formik.values.regCode}
							onChange={formik.handleChange}
							error={formik.touched.regCode && Boolean(formik.errors.regCode)}
							helperText={formik.touched.regCode && formik.errors.regCode}
						/>
					</Grid>
					<Grid item xs={12}>
						<TextField
							required
							id="lastName"
							name="lastName"
							label="Last Name"
							fullWidth
							variant="outlined"
							value={formik.values.lastName}
							onChange={formik.handleChange}
							error={formik.touched.lastName && Boolean(formik.errors.lastName)}
							helperText={formik.touched.lastName && formik.errors.lastName}
						/>
					</Grid>
					<Grid item xs={12}>
						<LocalizationProvider dateAdapter={AdapterDateFns}>
							<DatePicker
								label="Date of birth"
								id="dob"
								name="dob"
								value={moment(formik.values.dob)}
								onChange={(date) => {
									if (moment(date).isValid()) {
										formik.setFieldValue('dob', moment(date));
									} else {
										formik.setFieldValue('dob', null);
									}
								}}
								renderInput={(params) => <TextField
									required
									{...params}
									error={Boolean(formik.errors.dob)}
									helperText={formik.errors.dob}
								/>}
							/>
						</LocalizationProvider>
					</Grid>
				</Grid>
				<Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
					<Button
						variant="contained"
						sx={{ mt: 3, ml: 1 }}
						type="submit"
					>
						Next
					</Button>
				</Box>
			</form>
		</React.Fragment>
	);
}